/* eslint-disable max-len */
import {path, apiVersion, DEFAULT_TIMEOUT, setErrorApi} from '@/utils/constants';
import {handleErrorCustom} from '@/utils/errorHandling';
import {useAxios} from '@sttedra_ui/framework';

// #region Globals
const {base} = useAxios();
const servicio = 'ConfiguracionUsuario';
// #endregion

async function getConfiguracionUsuario() {
  const url = `${path}${servicio}/GetConfiguracionUsuario?${apiVersion}`;
  try {
    const {data: response} = await base.get(url, {timeout: DEFAULT_TIMEOUT});
    return response.objetoSalida;
  } catch (error) {
    if (error.code === 'ERR_NETWORK') setErrorApi();
    handleErrorCustom(error);
  }
}

async function postAddConfiguracionUsuario(_id, _data) {
  const url = `${path}${servicio}/${_id}?${apiVersion}`;
  try {
    const {data: response} = await base.post(url, _data, {timeout: DEFAULT_TIMEOUT});
    return response.success;
  } catch (error) {
    if (error.code === 'ERR_NETWORK') setErrorApi();
    handleErrorCustom(error);
  }
}

export {
  getConfiguracionUsuario,
  postAddConfiguracionUsuario,
};
